import React, { FC } from 'react';
import cx from 'classnames';

import { Longdash } from '~/utils';

import './styles.less';

export interface TextFieldProps {
  children: any;
  label?: any;
  className?: string;
  mode?: 'vertical' | 'horizontal';
}

const TextField: FC<TextFieldProps> = (props) => {
  const { children, label, mode = 'vertical', className } = props;
  const handleChildren = (value: any) => {
    switch (typeof value) {
      case 'number':
        return value;
      default:
        return value || Longdash;
    }
  };

  if (mode === 'vertical') {
    return (
      <div className={cx('TextField', className)}>
        {label && <div className="TextField-Label">{label}</div>}
        <div className="TextField-Text">{handleChildren(children)}</div>
      </div>
    );
  }
  if (mode === 'horizontal') {
    return (
      <div className={cx('TextField__horizontal', className)}>
        {label && <div className="TextField-Label__horizontal">{label}</div>}
        {handleChildren(children)}
      </div>
    );
  }
  return null;
};

export default TextField;
